import React from 'react';
import { Placeholder } from '../Placeholder';
import { FadeUp } from '../FadeUp';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section data-id="element-80" data-mp="1hify77104sdc">
      <div className="bg-ink px-5 py-10" data-id="element-81" data-mp="1ckwngh3iixq5">
        <div className="mx-auto w-full max-w-[620px] text-center" data-id="element-82" data-mp="1clzeqq4qz26l">
          <h2 className="text-[26px] font-extrabold uppercase text-white md:text-[34px]" data-id="element-83" data-mp="18k4bhg39aeq6">
            🎁 But wait… that's not all 🎁
          </h2>
          <p className="mx-auto mt-3 max-w-[480px] text-[16px] text-white/75" data-id="element-84" data-mp="2592873ukgmpz">
            If you made it this far, we've got more gifts for you and your kid
          </p>
        </div>
      </div>

      <div className="px-5 py-14 md:py-20" data-id="element-85" data-mp="1w7c5v2z5c3df">
        <FadeUp className="mx-auto w-full max-w-[620px]" data-id="element-86" data-mp="1rac8rhk9yayg">
          <ul className="grid grid-cols-2 gap-4" data-id="element-87" data-mp="1r9sucatu24p6">
            {bonuses.map((bonus, index) => <li key={bonus.title} className="text-center" data-id="element-88" data-mp="kvbdzf6zjytg" data-mpi={index}>
                {bonus.image ? <img src={bonus.image} alt={`${bonus.title} cover`} width={1024} height={1536} loading="lazy" decoding="async" className="mx-auto block w-full" style={{
              aspectRatio: '2 / 3',
              objectFit: 'contain'
            }} data-id="element-89" data-mp="ftm1dv447d39" /> : <Placeholder label={`BONUS ${index + 1} COVER`} ratio="2 / 3" className="w-full" data-id="element-90" data-mp="1atwfdq1h45be" />}
                <p className="mt-3 text-[12px] font-extrabold uppercase tracking-wide text-brand" data-id="element-91" data-mp="10tm07zvvontl">
                  Bonus {index + 1} 🎁
                </p>
                <h3 className="mt-1 text-[14px] font-extrabold" data-id="element-92" data-mp="n4buh1lrexzh">{bonus.title}</h3>
                <p className="mt-1 text-[12px] text-ink/65" data-id="element-93" data-mp="r4vs06a8w3m5">{bonus.description}</p>
                <p className="mt-1 text-[12px] text-pain line-through" data-id="element-94" data-mp="d41hni3mzsku">{bonus.value}</p>
              </li>)}
          </ul>

          <p className="mt-10 text-center text-[20px] font-extrabold" data-id="element-95" data-mp="i2mf59ri7y5l">
            Total bonus value: <span className="line-through" data-id="element-96" data-mp="2ju4py6s7uyfq">$184</span> →{' '}
            <span className="text-gain" data-id="element-97" data-mp="2f1bpvw7p0e9z">FREE</span>
          </p>
        </FadeUp>
      </div>
    </section>;
}